'use strict';
angular.module('productManageMentAppChannelModule', [
    'mangeProAppChannelCtrlModule',
    'productManageMentAppChannelRouterModule'
]).
controller('productManageMentAppChannelCtrl', ['$scope', '$rootScope', '$q', '$state', '$modal', '$stateParams', 'trsHttpService', 'modalDialog', 'productMangageMentAppService', 'localStorageService', "globleParamsSet", "websiteService", "editingCenterService", "sortOfChannelService", "trsspliceString",
    function($scope, $rootScope, $q, $state, $modal, $stateParams, trsHttpService, modalDialog, productMangageMentAppService, localStorageService, globleParamsSet, websiteService, editingCenterService, sortOfChannelService, trsspliceString) {
        initStatus();
        initData();
        //获取栏目操作权限开始
        function getChnlRights() {
            productMangageMentAppService.getRight($stateParams.site, "", "appsetsite.channel").then(function(data) {
                $scope.status.right = data;
            });
        }
        //获取栏目操作权限结束 
        /**
         * [positionToChannel description]定位到栏目
         * @return null [description]
         */
        $scope.positionToSite = function(siteMsg) {
            $state.go("manageconfig.productmanage.app.channel", { site: siteMsg.CHANNELID }, { reload: true });
        };
        /**
         * [clickSiteDirected description]点击频道重定向开始
         * @return null [description]
         */
        $scope.clickChnlDirected = function(item) {
            productMangageMentAppService.getCloumnAccessAuthority(item.CHANNELID).then(function(data) {
                //將权限信息存入缓存，用于底部路由区加载使用开始
                localStorageService.remove("appRightOperType_channel"); //初始化缓存
                localStorageService.set("appRightOperType_channel", {
                    type: data.router,
                    data: data.data
                });
                $state.go("manageconfig.productmanage.app." + data.router, {
                    channel: item.CHANNELID,
                    parentchnl: item.CHANNELID,
                    status: item.STATUS
                }, { reload: true });
            });
            //將权限信息存入缓存，用于底部路由区加载使用结束
            // $state.go("manageconfig.productmanage.app." + "column", {
            //     channel: item.CHANNELID,
            //     parentchnl: item.CHANNELID
            // });
        };
        //初始化数据
        function initData() {
            requestData().then(function(data) {
                $scope.appItems = data;
                $scope.appItems !== "" ? $scope.selectedChannel = $scope.appItems[0] : "";
            });
            editingCenterService.getSiteInfo($stateParams.site).then(function(data) {
                $scope.data.siteMsg = data;
            });
        }
        //数据请求函数
        function requestData() {
            var deferred = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.appItems = data;
                $state.transitionTo($state.current, $stateParams, {
                    reload: false
                });
                deferred.resolve(data);
            });
            return deferred.promise;
        }
        $scope.btnClick = function(item) {
            $scope.click_btn = item;
        };
        //鼠标移入
        $scope.getInSelectedChl = function(appItem) {
            $scope.selectedChannel = appItem;
        };
        //搜索
        $scope.searchChannelByName = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.methodname = "queryChannelsBySiteForCloud";
                $scope.params.ChnlDesc = $scope.searchWord;
                requestData().then(function(data) {
                    $scope.appItems = data;
                });
            }
        };

        function initStatus() {
            $scope.params = {
                serviceid: "mlf_appconfig",
                methodname: "queryChannelsBySiteForCloud",
                SiteId: $stateParams.site
            };
            $scope.status = {
                PmmAppChnlSelected: $stateParams.appselect,
                statusOptions: [{
                    name: "全部状态",
                }, {
                    name: "启用",
                    value: 0,
                }, {
                    name: "停用",
                    value: -1
                }],               
                selectedArray: [],
                selectedStatus: [],
                right: {}, //栏目列表操作权限
                status: $stateParams.status
            };
            $scope.status.selectStatus=$scope.status.statusOptions[0];
            $scope.data = {
                siteMsg: "",
            };
            $scope.selectedChannel = "";
            getChnlRights();
        }
        /**
         * [selectStatus description]根据状态筛选频道
         * @params [{appItem}] [description]
         * @return null [description]
         */
        $scope.selectStatus = function() {
            $scope.params.status = $scope.status.selectStatus.value;
            requestData();
        };
        /**
         * [enableDisable description]启用停用频道
         * @return null [description]
         */
        $scope.enableDisable = function(appItem) {
            if (appItem.STATUS === '0') {
                $scope.disableChannel(appItem);
            } else {
                $scope.reductionViews(appItem);
            }
        };
        /**
         * [disableChannel description]停用频道
         * @return null [description]
         */
        $scope.disableChannel = function(appItem) {
            var checkParams = {
                serviceid: "mlf_appconfig",
                methodname: "deleteChannelCondition",
                ChannelId: appItem.CHANNELID
            };
            var deleteParams = {
                serviceid: "mlf_appconfig",
                methodname: "deleteChannel",
                ChannelId: appItem.CHANNELID,
                TopChannelId: '0'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, "post")
                .then(function(data) {
                    modalDialog.inputModel("停用", "停用原因（选填）", function(data) {
                        productMangageMentAppService.inputPassword(function(password) {
                            LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                                deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "post")
                                    .then(function(data) {
                                        modalDialog.alertType("停用频道成功", "", "success", false);
                                        requestData();
                                    });
                            });
                        });
                    });
                });
        };
        /**
         * [reductionViews description]启用频道
         * @params [{appItem}] [description] 频道信息
         * @return null [description]
         */
        $scope.reductionViews = function(appItem) {
            modalDialog.alertType("确定启用该频道？", "", "ask", true, function(data) {
                var reSiteParams = {
                    serviceid: "mlf_appconfig",
                    methodname: "restoreChannels",
                    ObjectIds: appItem.CHANNELID,
                    SiteId: $stateParams.site,
                    TopChannelId: '0',
                    RestoreAll: false
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), reSiteParams, "post")
                    .then(function(data) {
                        modalDialog.alertType("启用成功", "", "success", false, function() {
                            initData();
                        });
                    });
            });
        };

        /**
         * [sortOfSites description] 频道排序
         * @return {[type]} [description]
         */
        $scope.channelOfSites = function() {
            if ($scope.status.selectedArray.length !== 1) {
                modalDialog.alertType("请选择一个频道", "", "warning", false);
                return;
            }
            var index = $scope.appItems.indexOf($scope.status.selectedArray[0]) + 1;
            sortOfChannelService.sorts("app", index, $scope.status.selectedArray[0], $scope.appItems, function(data) {
                if (data.ISSUCCESS == "true") {
                    $state.go($state.current.name, $stateParams, { reload: true });
                }

            });

        };

        /**
         * [batDelete description] 批量删除方法
         * @return {[type]} [description]
         */
        $scope.batDelete = function() {
            if ($scope.status.selectedArray.length == 0) {
                modalDialog.alertType("请先选择一个频道", "", "warning", false);
                return;
            } else {
                modalDialog.alertType("确定要删除选中的频道吗", "", "warning", true, function() {
                    $scope.deleteViews($scope.status.selectedArray);
                });
            }
        };
        /**
         * [deleteSite description]删除频道
         * @params [{chnlId}] [description] 频道信息
         * @return null [description]
         */
        $scope.deleteViews = function(chnl) {
            $scope.data.selectChannelIds = trsspliceString.spliceString(chnl, "CHANNELID", ",");
            var ckConditionParamas = {
                serviceid: "mlf_appconfig",
                methodname: "checkChannelCondition",
                ChannelIds: $scope.data.selectChannelIds
            };
            var deleteParams = {
                serviceid: "mlf_appconfig",
                methodname: "removeChannels",
                ChannelIds: $scope.data.selectChannelIds,
                TopChannelId: '0',
                PassWord: ""
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), ckConditionParamas, "get")
                .then(function(data) {
                    productMangageMentAppService.inputPassword(function(password) {
                        LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                            deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "get")
                                .then(function(data) {
                                    modalDialog.alertType("删除成功", "", "success", false);
                                    $state.go($state.current.name, $stateParams, { reload: true });
                                });
                        });
                    });
                });
        };
        /**
         * [selectAll description]全选
         * @params [{}] [description]
         * @return null [description]
         */
        $scope.selectAll = function() {
            $scope.status.selectedArray = $scope.status.selectedArray.length == $scope.appItems.length ? [] : [].concat($scope.appItems);
            if ($scope.status.selectedArray.length > 0) {
                for (var i = 0; i < $scope.status.selectedArray.length; i++) {
                    if ($scope.status.selectedArray[i].STATUS == -1) {
                        $scope.status.selectedStatus.push($scope.status.selectedArray[i].CHANNELID);
                    }
                }
            } else {
                $scope.status.selectedStatus = [];
            }
        };
        /**
         * [selectDoc description]单选
         * @params [{}] [description]
         * @return null [description]
         */
        $scope.selectDoc = function(appItem) {
            if ($scope.status.selectedArray.indexOf(appItem) < 0) {
                $scope.status.selectedArray.push(appItem);
                if (appItem.STATUS == -1) {
                    $scope.status.selectedStatus.push(appItem.CHANNELID);
                }
            } else {
                $scope.status.selectedArray.splice($scope.status.selectedArray.indexOf(appItem), 1);
                if (appItem.STATUS == -1) {
                    $scope.status.selectedStatus.splice($scope.status.selectedStatus.indexOf(appItem.CHANNELID), 1);
                }
            }
        };
        /**
         * [addChildren description] 新增子站点
         */
        $scope.addChildren = function(channel) {
            var column = {
                title: "新增子栏目",
                isColumn: true
            };
            addColumn(column, channel, function() {});
        };
        //修改弹窗
        $scope.modify = function(appItem) {
            var column = {
                title: "修改频道",
                isColumn: false
            };
            $scope.modifyViews(column, function(data) {

            }, appItem);
        };
        //新增弹窗
        $scope.add = function() {
            var column = {
                title: "新建频道",
                isColumn: false
            };
            $scope.modifyViews(column, function(data) {

            }, "");
        };
        //发布栏目
        $scope.publish = function(appItem) {
            websiteService.websitePublish(appItem.CHANNELID, "101");
        };
        /**
         * [addColumn description]
         */
        function addColumn(column, channel, successFn) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/app/channel/template/channel_modify_tpl.html",
                windowClass: 'productManageMent-app-channel-modify',
                backdrop: false,
                controller: "appcolumnModifyCtrl",
                resolve: {
                    column: function() {
                        return column;
                    },
                    successFn: function() {
                        return successFn;
                    },
                    appChannel: function() {
                        return "";
                    },
                    selfChannel: function() {
                        return channel;
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                $scope.params = result;
                $scope.params.serviceid = "mlf_appconfig";
                $scope.params.methodname = "saveNewChnl";
                $scope.params.TopChannelId = channel.CHANNELID;
                $scope.params.CHNLDATAPATH = result.DATAPATH;
                requestData().then(function() {
                    modalDialog.alertType(column.title + '成功', "", "success", false, function() {});
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
            });
        }
        //修改弹窗方法
        $scope.modifyViews = function(column, successFn, appChannel) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/app/channel/template/channel_modify_tpl.html",
                windowClass: 'productManageMent-app-channel-modify',
                backdrop: false,
                controller: "appchannelModifyCtrl",
                resolve: {
                    column: function() {
                        return column;
                    },
                    successFn: function() {
                        return successFn;
                    },
                    appChannel: function() {
                        return appChannel;
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                $scope.params = result;
                $scope.params.serviceid = "mlf_appconfig";
                $scope.params.methodname = "saveNewChnl";
                $scope.params.TopChannelId = '0';
                $scope.params.CHNLDATAPATH = result.DATAPATH;
                requestData().then(function() {
                    modalDialog.alertType(column.title + '成功', "", "success", false, function() {});
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
            });
        };
        //栏目预览
        $scope.preview = function(appItem) {
            websiteService.websiteChannelPreview(appItem);
        };
        /**
         * [getChildren description] 获取频道本身的权限
         * @param  {[type]} item [description] 频道数据
         * @return {[type]}      [description]
         */
        $scope.getChildrenRight = function(item) {
            productMangageMentAppService.getRight("", item.CHANNELID, "appsetchannel.channel").then(function(data) {
                item.right = data;
            });
        };
        /**
         * [addChildren description] 新建子栏目
         * @return {[type]}      [description]
         */
        $scope.batAddChildren = function() {
            if ($scope.status.selectedArray.length !== 1) {
                modalDialog.alertType("请选择一个频道", "", "warning", false);
                return;
            }
            if (!$scope.status.selectedArray[0].right.channel || !$scope.status.selectedArray[0].right.channel.xinjian) {
                modalDialog.alertType("您没有该频道的新增权限", "", "warning", false);
                return;
            }
            $scope.addChildren($scope.status.selectedArray[0]);
        };
    }
]);